import React from "react"
import Paper from "material-ui/Paper"
import ImageLoader from "../../../misc/ImageLoader"
import strings from "../../../../localization/strings"
import { green500, green50, orange900, deepOrange50, amber500 } from "material-ui/styles/colors"
import { IBiometricException, IPunchException, EExceptionState } from "../../../../models"
import * as exceptionHelper from "../../../../helpers/exceptionHelper"
import ExceptionBody from "../exception_body/ExceptionBody"
import AccountStore from "../../../../stores/AccountStore"
import FontIcon from "material-ui/FontIcon"
import ExceptionReviewedInfo from "../exception_body/ExceptionReviewedInfo"
import * as utils from "../../../../helpers/utils"

interface IProps {
	exception: IPunchException
	biometricException: IBiometricException
}

const BiometricExceptionInfo: React.SFC<IProps> = (props: IProps) => {
	const exceptionState = exceptionHelper.getExceptionState(props.exception)
	const showLiveness = AccountStore.getLivenessDetectionEnabled()
	const settings = AccountStore.getCurrentAccountSettings()
	const biomSettings = settings && settings.BiometricSettings
	const livenessThreshold = biomSettings ? biomSettings.DefaultLivenessThreshold : 0.7
	return (
		<div
			style={{
				background: exceptionState === EExceptionState.Review ? amber500 : exceptionState === EExceptionState.Approved ? green500 : orange900,
				color: exceptionState === EExceptionState.Review ? orange900 : exceptionState === EExceptionState.Approved ? green50 : deepOrange50,
				padding: 10,
				minHeight: 350,
				position: "relative"
			}}
		>
			<ExceptionReviewedInfo
				style={{ position: "absolute", right: 15, bottom: 15 }}
				hierarchyId={props.biometricException.Record.Punch.HierarchyItemId}
				jobId={props.biometricException.Record.Punch.JobId}
				exception={props.exception}
			/>
			<Paper style={{ float: "left" }}>
				<ImageLoader
					url={props.biometricException.Record.Punch.ImageS3Url}
					fixedHeight={350}
					maxWidth={275}
					src={"/punches/image/" + props.biometricException.Record.Punch.ImageID}
				/>
			</Paper>
			<div style={{ float: "left", marginLeft: 20 }}>
				<div className="exception-review-header-score">
					{props.biometricException && (props.biometricException.Record.Punch.MetaData.BiometricScore * 100).toFixed(1)}%
				</div>
				<h2 style={{ textTransform: "uppercase", marginTop: 0, marginBottom: 5 }}>
					{exceptionState === EExceptionState.Review &&
						strings.formatString(strings.Is_this_x, props.biometricException.Record.UserFirstName, props.biometricException.Record.UserLastName)
					}
				</h2>
				{showLiveness && props.biometricException && (
					<div className="liveness-score" style={{ marginBottom: 15, marginTop: 0 }}>
						<FontIcon
							className="fa fa-video-camera"
							style={{
								fontSize: 16,
								color: "#E65100",
								marginRight: 8
							}}
						/>
						<span>
							<b>
								{strings.Liveness_Score}: {utils.getLivenessScore(props.biometricException.Record.Punch)}
								- {props.biometricException.Record.Punch.MetaData.LivenessScore > livenessThreshold ? "Pass" : "Fail"}
							</b>
						</span>
					</div>
				)}
				<ExceptionBody
					record={props.biometricException.Record}
				/>
			</div>
			<div style={{ float: "right" }}>
				<span className="fa-stack" style={{ fontSize: 90, marginTop: 75 }}>
					<i className="fa fa-square-o fa-stack-2x" />
					<i className={`fa fa-${exceptionState === EExceptionState.Review ? "warning" : exceptionState === EExceptionState.Approved ? "check" : "close"} fa-stack-1x`} />
				</span>
			</div>
			<div style={{ clear: "both" }} />
		</div>
	)
}

export default BiometricExceptionInfo
